<template>
  <div>
    <form-modal
      ref="UsersModal"
      :formSchema="userFormSchema"
      title="إضافة مستخدم وزارة"
      v-model="isAddNewUserSidebarActive"
      @confirm="
        addNewUser($event, true);
        $refs.refUserListTable.refreshTable();
        isAddNewUserSidebarActive = false;
      "
    />

    <form-modal
      ref="refUpdateUsersModal"
      :formSchema="userFormSchema"
      title="تعديل مستخدم الوزارة"
      v-model="isUpdateUserModalOpen"
      @confirm="
        updateUser($event, true);
        $refs.refUserListTable.refreshTable();
        isUpdateUserModalOpen = false;
      "
    />
    <div class="pb-1 d-flex align-items-center justify-content-between">
      <div class="d-flex w-100 align-items-center">
        <form-input class="w-25 mx-1" label="الاسم" v-model="userSearchKey" />
        <b-button
          :variant="isArchivedView ? 'danger' : 'outline-danger'"
          @click="toggleArchived"
          >الحسابات المؤرشفة
        </b-button>
      </div>
      <b-button
        v-can="{ slug: 'ministry_users_rp', action: 'C' }"
        variant="success"
        @click="isAddNewUserSidebarActive = true"
      >
        <span class="text-nowrap">إضافة </span>
      </b-button>
    </div>

    <data-table
      ref="refUserListTable"
      class="position-relative"
      ep="v2/ministry/ministry-users"
      responsive
      :fields="tableColumns"
      primary-key="id"
    >
      <!-- Column: User -->
      <template #cell(full_name)="data">
        <b-media vertical-align="center">
          <template #aside>
            <b-avatar
              size="32"
              :src="data.item.avatar"
              :text="avatarText(data.item.full_name)"
              :to="{
                name: 'settings-ministry-users-show',
                params: { id: data.item.id },
              }"
            />
          </template>
          <b-link
            :to="{
              name: 'settings-ministry-users-show',
              params: { id: data.item.id },
            }"
            class="font-weight-bold d-block text-nowrap"
          >
            {{ data.item.full_name }}
          </b-link>
          <small class="text-muted">{{ data.item.username }}</small>
        </b-media>
      </template>

      <!-- Column: Role -->
      <template #cell(is_blocked)="data">
        <div class="text-nowrap">
          <span>{{ data.item.is_blocked ? "نعم" : "لا" }}</span>
        </div>
      </template>
      <template #cell(is_locked)="data">
        <div class="text-nowrap">
          <span>{{ data.item.is_locked ? "نعم" : "لا" }}</span>
        </div>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <b-dropdown
          v-if="!isArchivedView"
          variant="link"
          no-caret
          :right="$store.state.appConfig.isRTL"
        >
          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>
          <b-dropdown-item
            v-can="{ slug: 'ministry_users_rp', action: 'S' }"
            :to="{
              name: 'settings-ministry-users-show',
              params: { id: data.item.id },
            }"
          >
            <feather-icon icon="FileTextIcon" />
            <span class="align-middle ml-50">التفاصيل</span>
          </b-dropdown-item>

          <!-- <b-dropdown-item
            v-can="{ slug: $route.meta.slug, action: 'U' }"
            @clcik="
              $refs.updateUsersModal.init({
                ...data.item,
                governorate_id: data.item.governorate.id,
              });
              isUpdateUserModalOpen = true;
            "
          >
            <feather-icon icon="EditIcon" />
            <span class="align-middle ml-50">تعديل</span>
          </b-dropdown-item> -->

          <b-dropdown-item
            v-can="{ slug: 'ministry_users_rp', action: 'D' }"
            @click="onDelete(data.item.id)"
          >
            <feather-icon icon="Trash2Icon" />
            <span class="align-middle ml-50">حذف</span>
          </b-dropdown-item>
        </b-dropdown>
        <b-button
          v-can="{ slug: 'ministry_users_rp', action: 'O' }"
          v-else
          @click="onRestoreClicked(data.item.id)"
          variant="success"
        >
          استعادة
        </b-button>
      </template>
    </data-table>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BButton,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import { ref } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import useUsersList from "./useUsersList";
import DataTable from "@/components/data-table/index.vue";
import FormModal from "@/components/FormModal.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import debounce from "lodash.debounce";
import formAutocomplete from "@/components/form-autocomplete";
import formInput from "@/components/form-input";
export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BButton,

    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    DataTable,
    FormModal,
    ToastificationContent,
    formAutocomplete,
    formInput,
  },

  watch: {
    userSearchKey: debounce(function (value) {
      this.$refs.refUserListTable.setQueryParams({
        full_name: this.userSearchKey ? this.userSearchKey : null,
        archived: this.isArchivedView,
      });
      this.$refs.refUserListTable.refreshTable();
    }, 300),
  },
  methods: {
    toggleArchived() {
      this.isArchivedView = !this.isArchivedView;
      this.$refs.refUserListTable.setQueryParams({
        archived: this.isArchivedView,
      });
      this.$refs.refUserListTable.refreshTable();
    },
    onRestoreClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من استعادة المستخدم ؟", {
          title: "تأكيد الاستعادة",
          size: "sm",
          okVariant: "success",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async () => {
          await this.restoreUser(id, true);
          this.$refs.refUserListTable.refreshTable();
        });
    },
    onDelete(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف المستخدم ؟", {
          title: "تأكيد حذف المستخدم",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await this.deleteUser(id, true);
            this.$refs.refUserListTable.refreshTable();
          }
        });
    },
  },
  setup() {
    const isAddNewUserSidebarActive = ref(false);
    const isUpdateUserModalOpen = ref(false);

    const userFormSchema = {
      full_name: {
        component: "FormInput",
        key: "full_name",
        attrs: {
          label: "الاسم الكامل",
          rules: "required",
        },
      },
      username: {
        component: "UsernameInput",
        checkEp : "v2/ministry/check-unique",
        key: "username",
        attrs: {
          label: "اسم المستخدم",
          rules: "required",
          isMinistry: true,
        },
      },
      email: {
        component: "EmailInput",
        checkEp : "v2/ministry/check-unique",
        key: "email",
        attrs: {
          label: "البريد الإلكتروني*",
          rules: "required|email",
          isMinistry: true,
        },
      },
      mobile: {
        component: "MobileInput",
        key: "mobile",
        attrs: {
          id: "mobile-input",
          label: "رقم الموبايل*",
          rules: "required",
          isMinistry: true,
        },
      },
      phone: {
        component: "PhoneInput",
        key: "phone",
        attrs: {
          id: "phone-input",
          label: " رقم الهاتف",

          isMinistry: true,
        },
      },
      dob: {
        component: "FormMask",
        key: "dob",
        attrs: {
          label: "تاريخ الميلاد",
          options: "date",
          rules: "required",
          placeholder: "YYYY-MM-DD",
        },
      },
      governorate_id: {
        component: "FormSelect",
        key: "governorate_id",
        attrs: {
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
          id: "users_gov_manage_",
          label: "المحافظة",
          ep: "v2/ministry/selects/governorates",
          rules: "required",
        },
      },
      is_blocked: {
        component: "FormSelect",
        key: "is_blocked",
        attrs: {
          id: "is_blocked",
          label: "حساب محظور",
          rules: "required",
          reduce: (el) => el.value,
          options: [
            { label: "نعم", value: 1 },
            { label: "لا", value: 0 },
          ],
        },
      },
      is_locked: {
        component: "FormSelect",
        key: "is_locked",
        attrs: {
          id: "is_locked",
          label: "حساب مقفل",
          rules: "required",
          reduce: (el) => el.value,
          options: [
            { label: "نعم", value: 1 },
            { label: "لا", value: 0 },
          ],
        },
      },
      ministry_user_type: {
        component: "FormSelect",
        key: "ministry_user_type",
        attrs: {
          id: "ministry_user_type",
          label: "حساب مركزي",
          rules: "required",
          reduce: (el) => el.value,
          options: [
            { label: "نعم", value: 1 },
            { label: "لا", value: 0 },
          ],
        },
      },
      roles: {
        component: "FormSelect",
        key: "roles",
        attrs: {
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name,
          id: "roles-select",
          label: "الأدوار",
          ep: "v2/ministry/selects/roles?isMinistry=true",
          rules: "required",
          closeOnSelect: false,
          multiple: true,
        },
      },
      password: {
        component: "GeneratePassword",
        key: "password",
        attrs: {
          id: "password",
          label: "كلمة السر ",
          rules: "required|min:8",
        },
      },
      password_must_change: { key: "password_must_change" },
    };
    const {
      tableColumns,
      refUpdateUsersModal,
      refUserListTable,

      resolveUserRoleIcon,
      resolveUserStatusVariant,

      //processes
      addNewUser,
      updateUser,
      deleteUser,
      restoreUser,
    } = useUsersList();

    const userSearchKey = ref("");
    const isArchivedView = ref(false);

    return {
      // Sidebar
      isAddNewUserSidebarActive,
      isUpdateUserModalOpen,
      tableColumns,
      refUpdateUsersModal,
      // Filter
      avatarText,

      // UI
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters

      userFormSchema,
      addNewUser,
      updateUser,
      deleteUser,
      restoreUser,
      userSearchKey,
      isArchivedView,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

>
